import Delay from './delay.container'

export default Delay
